import { ENDPOINTS } from "@constants";
import AbstractService from "./AbstractService";
import NexusService from "./NexusService";
import FeatureFlagService from "./FeatureFlagService";

export default class JobEventDraftsService extends AbstractService {
	static draftsEndpoint = ENDPOINTS.jobEventDrafts;

	static jobEventDraftsApi = NexusService.jobEventDraftsApi;

	static jobEventDraftsFeature = "use_api_core_endpoints_job_event_drafts";

	static getJobDrafts(pageNumber) {
		if (FeatureFlagService.isEnabled(this.jobEventDraftsFeature)) {
			const request = {
				pageNumber,
				displayCount: 25,
			}
			return this.jobEventDraftsApi.getPaginatedJobEventDrafts(request)
			.then(response => {
				const apiResponse = {
					data: response,
				};
				return apiResponse;
			});
		}
		return this.get({
			endpoint: this.draftsEndpoint,
			queryParams: { pageNumber, displayCount: 25 },
		});
	}

	static getJobDraft(draftId) {
		if (FeatureFlagService.isEnabled(this.jobEventDraftsFeature)) {
			const request = {
				id: draftId,
			}
			return this.jobEventDraftsApi.getJobEventDraft(request)
			.then(response => {
				const apiResponse = {
					data: response,
				};
				return apiResponse;
			});
		}
		return this.get({
			endpoint: `${this.draftsEndpoint}/${draftId}`,
		});
	}

	static createJobDraft(data) {
		if (FeatureFlagService.isEnabled(this.jobEventDraftsFeature)) {
			const request = {
				jobEventDraftCreatePayload: {},
			}
			if (Object.hasOwn(data, "title")) {
				request.jobEventDraftCreatePayload.Title = data.title;
			}
			if (Object.hasOwn(data, "draftData")) {
				request.jobEventDraftCreatePayload.DraftData = data.draftData;
			}
			return this.jobEventDraftsApi.createJobEventDraft(request)
			.then(response => {
				const apiResponse = {
					data: response,
				};
				return apiResponse;
			});
		}
		return this.post({
			endpoint: this.draftsEndpoint,
			data,
		});
	}

	static updateJobDraft(data) {
		if (FeatureFlagService.isEnabled(this.jobEventDraftsFeature)) {
			const request = {
				id: data.id,
				jobEventDraftUpdatePayload: {},
			}
			if (Object.hasOwn(data, "title")) {
				request.jobEventDraftUpdatePayload.Title = data.title;
			}
			if (Object.hasOwn(data, "draftData")) {
				request.jobEventDraftUpdatePayload.DraftData = data.draftData;
			}

			return this.jobEventDraftsApi.updateJobEventDraft(request)
			.then(response => {
				const apiResponse = {
					data: response,
				};
				return apiResponse;
			});
		}
		return this.put({
			endpoint: this.draftsEndpoint,
			data,
		});
	}

	static deleteJobDraft(draftId) {
		if (FeatureFlagService.isEnabled(this.jobEventDraftsFeature)) {
			const request = {
				id: draftId,
			}
			return this.jobEventDraftsApi.deleteJobEventDraft(request)
			.then(response => {
				const apiResponse = {
					data: response,
				};
				return apiResponse;
			});
		}
		return this.del({
			endpoint: `${this.draftsEndpoint}/${draftId}`,
		});
	}

}
